var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChartEvolutionContainer',{attrs:{"title":_vm.$t(_vm.title),"evolution":""},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('highcharts',{attrs:{"options":_vm.chartOptions}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }